import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { useCandidatoNavegacao } from '../hooks';
import { useCandidatoListagem } from '../hooks';
import CandidatoHeader from './CandidatoHeader';
import CandidatoTable from './CandidatoTable';
import CandidatoFilter from './CandidatoFilter';

const CandidatoCard = ({
  id,
  showActions = false,
  enableRowClick = true,
  showFilter = true,
  showHeader = true
}) => {
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    setPaginaAtual,
    setQuantidadePorPagina
  } = useCandidatoListagem(id);
  const {
    handleRowClick,
    handleAdicionar,
    handleEditar
  } = useCandidatoNavegacao();
  return <>
    <Card>
      <CardBody>
        {showHeader && <CandidatoHeader totalRegistros={totalRegistros} onAdicionar={showActions ? handleAdicionar : undefined} />}

        {showFilter && <CandidatoFilter loading={filterLoading} onApply={handleFilterApply} onLimpar={handleLimparFiltros} />}

        <CandidatoTable
          data={data}
          loading={loading}
          onRowClick={enableRowClick ? handleRowClick : undefined}
          onEditar={showActions ? handleEditar : undefined}
          onExcluir={showActions ? handleExcluir : undefined}
          manualPagination={true}
          totalRegistros={totalRegistros}
          controlledPagination={
            {
              pageIndex: Math.max(0, (paginaAtual || 1) - 1),
              pageSize: quantidadePorPagina || 10
            }
          } 
          onPaginationChange={next => {
            if (next && typeof next.pageSize === 'number') setQuantidadePorPagina(next.pageSize);
            if (next && typeof next.pageIndex === 'number') setPaginaAtual(next.pageIndex + 1);
          }} />
      </CardBody>
    </Card>
  </>;
};

export default CandidatoCard;
